/* eslint-disable sort-keys-fix/sort-keys-fix */
import {
  isBicForbidden,
  isIbanMatchingCountry,
  isSwiftBicMatchingCountry,
} from '@shinetools/iban-bban-bic';
import { z } from 'zod';

import {
  ibanSchema,
  nonEmptyStringSchema,
  swiftBicSchema,
} from 'common/zod/schemas';

import locales from './locales';

const ALLOWED_BENEFICIARY_NAME_CHARACTERS_REGEX = /^[a-zA-z0-9-/?:().+\s]*$/;

export const addBeneficiaryFormSchema = z
  .object({
    name: nonEmptyStringSchema.regex(
      ALLOWED_BENEFICIARY_NAME_CHARACTERS_REGEX,
      locales.nonAllowedCharactersInName,
    ),
    country: nonEmptyStringSchema,
    iban: ibanSchema,
    swiftBic: swiftBicSchema,
    customLabel: z.string().trim(),
    isUserBankAccount: z.boolean().default(false),
  })
  .superRefine(({ country: countryCode, iban, swiftBic }, ctx) => {
    if (!isSwiftBicMatchingCountry({ countryCode, swiftBic })) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['swiftBic' satisfies keyof AddBeneficiaryFormSchema],
        message: locales.swiftBicNotMatchingCountry,
      });
    }
    if (isBicForbidden(swiftBic)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['swiftBic' satisfies keyof AddBeneficiaryFormSchema],
        message: locales.bicIsForbidden,
      });
    }
    if (!isIbanMatchingCountry({ countryCode, iban })) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['iban' satisfies keyof AddBeneficiaryFormSchema],
        message: locales.ibanNotMatchingCountry,
      });
    }
  });

export type AddBeneficiaryFormSchema = z.infer<typeof addBeneficiaryFormSchema>;
